import type { ReactNode } from "react";

import { cn } from "@/utils/shadcn-ui";

/**
 * Trailing "⌘K"-style label for a button whose action also has a shortcut. Hidden
 * from assistive tech, so put `aria-keyshortcuts` on the button itself — that is
 * where screen readers look for it.
 *
 * Pass `className` to re-colour it for a filled button, e.g. `text-white/70`.
 */
export function ShortcutHint({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      aria-hidden
      className={cn("ml-1 text-2xs text-muted-foreground", className)}
    >
      {children}
    </span>
  );
}
